import { useEffect, useState } from "react";
import { referenceService } from "src/api/references/referenceService";
import { ConnectionOfMedcardResponseDto } from "src/api/references/referenceServicesDtos";

interface UsePatientUpnReturn {
  upn: number | null;
  setUpn: (upn: number | null) => void;
  isFetchingUpn: boolean;
}

/**
 * Patient ID'den UPN değerini çeken custom hook
 * @param patientId - Hasta ID'si
 * @param initialUpn - Başlangıç UPN değeri (opsiyonel)
 * @returns upn, setUpn, isFetchingUpn
 */
export const usePatientUpn = (
  patientId: number,
  initialUpn?: number | null
): UsePatientUpnReturn => {
  const [upn, setUpn] = useState<number | null>(initialUpn ?? null);
  const [isFetchingUpn, setIsFetchingUpn] = useState(false);

  useEffect(() => {
    const fetchUpn = async () => {
      if (upn || patientId <= 0) return;
      
      try {
        setIsFetchingUpn(true);
        const res: ConnectionOfMedcardResponseDto =
          await referenceService.connectionsOfMedcard.getConnectionOfMedCard({
            pt: patientId,
          });
        const resolvedUpn = res?.data?.[0]?.upn;
        if (resolvedUpn) {
          setUpn(Number(resolvedUpn));
        }
      } catch (err) {
        console.error("getConnectionOfMedCard upn fetch error:", err);
      } finally {
        setIsFetchingUpn(false);
      }
    };

    fetchUpn();
  }, [upn, patientId]);

  return { upn, setUpn, isFetchingUpn };
};

